import html2canvas from "html2canvas";

/**
 * Captures the loan grid as a clean PNG with solid background.
 * Works correctly in both dark and light themes.
 */
export async function exportScreenshot(userName = "Admin") {
  const target = document.querySelector(".loan-container");
  if (!target) throw new Error("Could not find loan container");

  // Detect current theme
  const isDark = document.documentElement.getAttribute("data-theme") !== "light";
  const bgColor  = isDark ? "#0a0a0f" : "#f5f3ee";
  const textColor = isDark ? "#f0ece0" : "#1a1710";
  const gold = isDark ? "#c9a84c" : "#a8761e";
  const borderColor = isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.1)";

  // Hide UI-only elements during capture
  const hideEls = [
    ...document.querySelectorAll(".loan-actions"),
    ...document.querySelectorAll(".loan-top-bar"),
    ...document.querySelectorAll(".loan-tabs"),
  ];
  hideEls.forEach(el => (el.style.visibility = "hidden"));

  // Force solid background on container so nothing is transparent/cut off
  const origBg = target.style.background;
  target.style.background = bgColor;

  try {
    const canvas = await html2canvas(target, {
      scale: 2,
      useCORS: true,
      backgroundColor: bgColor,
      scrollY: -window.scrollY,
      windowWidth: document.documentElement.scrollWidth,
      windowHeight: document.documentElement.scrollHeight,
      logging: false,
      onclone: (clonedDoc) => {
        // In the cloned document, inject a watermark header onto the canvas
        const clonedContainer = clonedDoc.querySelector(".loan-container");
        if (!clonedContainer) return;

        // Create header banner
        const header = clonedDoc.createElement("div");
        header.style.cssText = `
          background: ${isDark ? "#111118" : "#ede9e0"};
          border-bottom: 2px solid ${gold};
          padding: 14px 24px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-family: 'DM Sans', sans-serif;
          margin-bottom: 4px;
        `;
        header.innerHTML = `
          <span style="font-size:18px;font-weight:700;color:${gold};font-family:'Playfair Display',serif;letter-spacing:0.02em;">
            ✦ MyLoanApp
          </span>
          <span style="font-size:11px;color:${isDark ? "#9e9b8e" : "#5c5648"};">
            ${userName} &nbsp;|&nbsp; ${new Date().toLocaleString("en-IN", {
              day: "2-digit", month: "short", year: "numeric",
              hour: "2-digit", minute: "2-digit"
            })}
          </span>
        `;
        clonedContainer.insertBefore(header, clonedContainer.firstChild);

        // Ensure all text nodes are visible (fix transparency issues)
        clonedContainer.style.background = bgColor;
        clonedContainer.style.color = textColor;

        // Hide UI-only clones
        clonedDoc.querySelectorAll(".loan-actions, .loan-top-bar, .loan-tabs")
          .forEach(el => (el.style.display = "none"));
      },
    });

    // Add a thin border/padding around the exported image
    const padded = document.createElement("canvas");
    const pad = 24;
    padded.width  = canvas.width  + pad * 2;
    padded.height = canvas.height + pad * 2;
    const ctx = padded.getContext("2d");
    ctx.fillStyle = bgColor;
    ctx.fillRect(0, 0, padded.width, padded.height);
    ctx.drawImage(canvas, pad, pad);

    // Subtle border
    ctx.strokeStyle = isDark ? "rgba(201,168,76,0.25)" : "rgba(168,118,30,0.2)";
    ctx.lineWidth = 2;
    ctx.strokeRect(1, 1, padded.width - 2, padded.height - 2);

    const link = document.createElement("a");
    const dateStr = new Date().toISOString().split("T")[0];
    link.download = `LoanPortfolio_${userName}_${dateStr}.png`;
    link.href = padded.toDataURL("image/png");
    link.click();

  } finally {
    hideEls.forEach(el => (el.style.visibility = ""));
    target.style.background = origBg;
  }
}
